<template>
  <div class="my-pooq-view-wrapper">
    <router-view name="popup"></router-view>
    <portal-target name="mypooq-popup"></portal-target>
    <header class="my-pooq-header" v-if="device === 'mobile'">
      <h1 class="a11y-hidden">웨이브</h1>
      <div class="header-top">
        <h2 class="hd-title">MY</h2>
        <button class="btn-back" type="button">
          <span class="a11y-hidden">뒤로 가기</span>
          <span class="icon-back" @click.prevent="close"><BackButton /></span>
        </button>
      </div>
      <!-- 마이페이지 gnb 메뉴 -->
      <common-main-menu :menu-items="menuItems" :menu-index="mainMenuIndex" :change-menu-fn="changeMainMenu" />
      <!-- 이용내역 서브 메뉴 -->
      <my-pooq-sub-menu :parent-index="mainMenuIndex" :menu-index="subMenuIndex" :change-menu-fn="changeSubMenu"/>
      <div v-if="device === 'mobile'">
        <portal-target name="delete-edit-header"></portal-target>
      </div>
    </header>
    <div v-if="device !== 'mobile'">
      <portal-target name="delete-edit-header"></portal-target>
    </div>
    <div :class="getWrapperClass" data-scroll-element="true">
      <router-view name="use_list_vod_history" key="use_list_vod_history"></router-view>
      <router-view name="use_list_movie_history" key="use_list_movie_history"></router-view>
      <router-view name="use_list_download" key="use_list_download"></router-view>
      <router-view name="taste_analysis" key="taste_analysis"></router-view>
      <router-view name="like_channel" key="like_channel"></router-view>
      <router-view name="like_theme" key="like_theme"></router-view>
      <router-view name="like_program" key="like_program"></router-view>
      <router-view name="like_movie" key="like_movie"></router-view>
      <router-view name="reserve_watch" key="reserve_watch"></router-view>
      <router-view name="subscription_ticket" key="subscription_ticket"></router-view>
      <router-view name="voucher_list_singular" key="voucher_list_singular"></router-view>
      <router-view name="voucher_list_package" key="voucher_list_package"></router-view>
      <router-view name="coin" key="coin"></router-view>
      <router-view name="coupon" key="coupon"></router-view>
      <router-view name="user_qna" key="user_qna"></router-view>
    </div>
  </div>

</template>

<script>
import CommonMainMenu from '@/components/lnb/mypooq/CommonMainMenu'
import MyPooqSubMenu from '@/components/lnb/mypooq/MyPooqSubMenu'
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
import VueSticky from 'vue-sticky'
import { mapGetters, mapMutations } from 'vuex'
import { infiniteScroll } from '@/common/directives'
// import { disableBodyScroll, enableBodyScroll } from '@/common/util/ui.utils'
import { MY_POOQ_MENU_LIST } from '@/common/menu.constant'
import utils from '@/common/util/utils'

export default {
  name: 'MyPooqView',
  components: {
    BackButton,
    CommonMainMenu,
    MyPooqSubMenu
  },
  directives: {
    VueSticky,
    infiniteScroll
  },
  data () {
    return {
      menuItems: MY_POOQ_MENU_LIST,
      mainMenuIndex: 0,
      subMenuIndex: 0,
      device: utils.cookies.getDevice()
      // device: 'mobile'
    }
  },
  computed: {
    ...mapGetters(['getBeforePathOpenMyPooq']),
    getWrapperClass () {
      let defaultClass = 'mypooq-wrap'
      const midx = +this.mainMenuIndex
      if (midx === 0 || midx === 6) {
        defaultClass += ' with-sub-menu with-editor-header'
      }
      if (midx === 2 || midx === 8) {
        defaultClass += ' with-sub-menu'
      }
      if (midx === 9) {
        defaultClass += ' with-editor-header padding-bottom'
      }
      if (this.device !== 'mobile') {
        defaultClass += ' not-mobile'
        if (midx === 0 || midx === 6) {
          defaultClass += ' padding-bottom'
        }
      }
      return defaultClass
    }
  },
  methods: {
    ...mapMutations(['setBeforePathOpenMyPooq']),
    close () {
      if (this.$route.params.isError) {
        this.setBeforePathOpenMyPooq('/')
      }
      this.$router.replace(this.getBeforePathOpenMyPooq)
    },
    changeMainMenu (mainMenuObject) {
      this.mainMenuIndex = mainMenuObject.index
      this.subMenuIndex = 0
      this.$router.push(mainMenuObject.path)
    },
    changeSubMenu (subMenuObject) {
      this.subMenuIndex = subMenuObject.index
      this.$nextTick(() => {
        this.$router.push(subMenuObject.path)
      })
    },
    getLastPath () {
      const lastPath = this.$route.name
      if (lastPath === 'mypooq') {
        this.$router.replace('/mypooq/use_list_vod_history')
      }
      switch (lastPath) {
        case 'use_list_vod_history':
          this.mainMenuIndex = 0
          this.subMenuIndex = 0
          break
        case 'use_list_movie_history':
          this.mainMenuIndex = 0
          this.subMenuIndex = 1
          break
        case 'use_list_download':
          this.mainMenuIndex = 0
          this.subMenuIndex = 2
          break
        case 'taste_analysis':
          this.mainMenuIndex = 1
          this.subMenuIndex = 0
          break
        case 'like_channel':
          this.mainMenuIndex = 2
          this.subMenuIndex = 0
          break
        case 'like_theme':
          this.mainMenuIndex = 2
          this.subMenuIndex = 1
          break
        case 'like_program':
          this.mainMenuIndex = 3
          this.subMenuIndex = 0
          break
        case 'like_movie':
          this.mainMenuIndex = 4
          this.subMenuIndex = 0
          break
        case 'reserve_watch':
          this.mainMenuIndex = 5
          this.subMenuIndex = 0
          break
        case 'voucher_list_singular':
          this.mainMenuIndex = 6
          this.subMenuIndex = 0
          break
        case 'voucher_list_package':
          this.mainMenuIndex = 6
          this.subMenuIndex = 1
          break
        case 'subscription_ticket':
          this.mainMenuIndex = 7
          this.subMenuIndex = 0
          break
        case 'coin':
          this.mainMenuIndex = 8
          this.subMenuIndex = 0
          break
        case 'coupon':
          this.mainMenuIndex = 8
          this.subMenuIndex = 1
          break
        case 'user_qna':
          this.mainMenuIndex = 9
          this.subMenuIndex = 0
          break
      }
    }
  },
  updated () {
    this.getLastPath()
  },
  created () {
    this.getLastPath()
  },
  mounted () {
    // disableBodyScroll()
  },
  beforeDestroy () {
    // enableBodyScroll()
  }
}
</script>

<style scoped>
  .my-pooq-view-wrapper {
    position: relative;
    top :0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    /*height: 100%;*/
    height: 100vh;
    z-index:3000;
    background-color: #1b1b1b;
  }

  .my-pooq-content-body {
    position: relative;
    width: 100%;
    /*padding-bottom: 40px;*/
    /*overflow-y:scroll;*/
    /*overflow-scrolling: touch;*/
    /*-webkit-overflow-scrolling: touch;*/
  }

  .my-pooq-content-body::-webkit-scrollbar {
    display: none;
    background-color: transparent
  }

  .my-pooq-header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
  }

  .mypooq-wrap {
    padding-top: 80px;
    width: 100%;
    height: 100vh;
  }

  .mypooq-wrap.not-mobile {
    top: 0 !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
    width: 100%;
    height: calc(100% - 56px);
  }

  .not-mobile.padding-bottom {
    /*padding-bottom: 56px !important;*/
  }

  .mypooq-wrap.with-sub-menu {
    padding-top: 120px;
  }
  .mypooq-wrap.with-sub-menu.with-editor-header {
    padding-top: 177px;
  }
  .mypooq-wrap.with-editor-header {
    padding-top: 137px;
  }
</style>
